<template>
  <div class="task-container" :id="task._id">
    <TaskName
      :taskName="task.taskName"
      :id="task._id"
      :taskType="'instruction'"
    />
    <section>
      <div id="table-title">
        <span>{{ $t('report_tasks.form_inspection') }}</span>
        <span>
          <span v-if="task.documentNumber" class="document-info"
            >{{ $t('report_tasks.document_number') }}
            <span>{{ task.documentNumber }}</span></span
          >
          <span v-if="task.revision" class="document-info"
            >{{ $t('report_tasks.revision') }}
            <span>{{ task.revision }}</span></span
          >
        </span>
      </div>
      <b-table :data="task.instructionData" :striped="true">
        <template #empty>
          <div class="has-text-centered">
            {{ $t('report_tasks.no_records') }}
          </div>
        </template>

        <template slot-scope="props">
          <b-table-column field="question" :label="$t('report_tasks.item')">
            {{ props.row.question }}
          </b-table-column>

          <b-table-column field="answer" :label="$t('report_tasks.answer')">
            <DisplayRichTextEditor
              :value="props.row.answer"
              :disabled="true"
              :apply-box-chrome="true"
            />
          </b-table-column>

          <b-table-column
            field="attachment"
            :label="$t('report_tasks.attachments_uc')"
          >
            {{ props.row.attachment }}
          </b-table-column>

          <b-table-column
            field="attachment"
            :label="$t('report_tasks.inspector')"
            :visible="isInternalReport"
          >
            {{ props.row.lastModifiedBy }}
          </b-table-column>

          <b-table-column
            field="lastModifiedAt"
            :label="$t('report_tasks.date')"
          >
            {{ props.row.lastModifiedAt }}
          </b-table-column>
        </template>
      </b-table>
    </section>

    <template v-for="item in task.subtabelsQuestions">
      <TableInspection v-if="item.tableData" :tableData="item" />
    </template>
    <Findings :task-prop="task" />
    <Attachments :task-prop="task" />
    <div id="divider" />
  </div>
</template>

<script>
import Findings from '../components/Findings';
import Attachments from '../components/Attachments';
import TableInspection from './TableInspection';
import TaskName from '../components/TaskName';
import ReportDataParser from '../../../mixins/Report/ReportDataParserMixin';
import DisplayRichTextEditor from '../../../components/RichTextEditor/DisplayRichTextEditor';

export default {
  name: 'Instruction',
  mixins: [ReportDataParser],
  props: {
    taskProp: {
      type: Object,
      required: true,
    },
  },
  components: {
    Findings,
    Attachments,
    TableInspection,
    TaskName,
    DisplayRichTextEditor,
  },

  computed: {
    task() {
      return this.taskProp;
    },
    formInspectionData() {
      return this.parseInstructionData(this.task);
    },
    isInternalReport() {
      return this.$store.getters['ReportsModule/isInternalReport'];
    },
    columns() {
      const columnsToReturn = [
        {
          field: 'question',
          label: this.$t('report_tasks.item'),
        },
        {
          field: 'answer',
          label: this.$t('report_tasks.answer'),
        },
        {
          field: 'attachment',
          label: this.$t('report_tasks.attachments_uc'),
        },
      ];
      if (this.isInternalReport) {
        columnsToReturn.push({
          field: 'lastModifiedBy',
          label: this.$t('report_tasks.inspector'),
        });
      }
      columnsToReturn.push({
        field: 'lastModifiedAt',
        label: this.$t('report_tasks.date'),
      });
      return columnsToReturn;
    },
  },
};
</script>

<style lang="scss" scoped>
#task-header {
  height: 35px;
  font-family: 'Siemens Sans';
  font-size: 18px;
  display: flex;
  align-items: center;
  margin-top: 35px;
}

#table-title {
  font-family: 'Siemens Sans';
  font-size: 18px;
  background-color: white;
  padding: 10px;
  border-bottom: solid;
  border-bottom-width: 1px;
  border-bottom-color: #ccc;
  display: flex;
  justify-content: space-between;
}

#divider {
  height: 10px;
  background-color: #ccc;
  width: 100%;
  margin-top: 20px;
}

#table-inspection {
  margin-top: 20px;
  background-color: #fff;
  padding: 10px;
  font-family: 'Siemens Sans';
  font-size: 18px;
}

.document-info {
  border-left: solid;
  border-width: 1px;
  padding: 5px;
  margin-left: 10px;
  border-color: #ccc;
}

.document-info span {
  color: #aaa;
}
</style>
